import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {Transaction} from '../enums/txn-type.enum';
import {FileService} from '../services/file.service';
import {PDFTemplateType} from "@app/shared/enums/pdf-template-type.enum";
import {Validation} from "@app/shared/enums/validation.enum";
import {PdfTemplate} from "@app/shared/classes/pdf-template";

@Component({
  selector: 'app-pdf-template-dropdown',
  templateUrl: './pdf-template-dropdown.component.html',
  styleUrls: ['./pdf-template-dropdown.component.css']
})
export class PdfTemplateDropdownComponent implements OnInit, OnChanges {

  @Input() txnType: Transaction;
  @Input() pdfTemplateType: PDFTemplateType;
  @Input() templateId: number;
  @Input() editable: boolean = true;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;

  // returns selected pdf template; if no pdf templates are available, return null
  @Output() handler: EventEmitter<PdfTemplate> = new EventEmitter();

  Validation: typeof Validation = Validation;

  pdfTemplates: SelectItem[];
  suggestedPdfTemplates: SelectItem[];
  selectedPdfTemplate: PdfTemplate;
  savedTxnType: Transaction;

  constructor(private fileService: FileService) {
  }

  ngOnInit() {
  }

  /**
   * @desc get pdf template(s) for the specified transaction type or id
   * @param changes - component input has changed
   * @returns: getPdfTemplates invoked if txnType or txnTypeId is specified and not null/undefined
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (this.txnType) {
      // only load new template if txnType or txnTypeId has changed
      if (this.txnType != this.savedTxnType) {
        this.savedTxnType = this.txnType;
        this.getPdfTemplates();
      } else {
        this.setPdfTemplate();
      }
    }
  }

  /**
   * @desc get pdf template(s) for the specified transaction type or id
   * @returns this.pdfTemplates - pdf templates for the specified transaction type or id, default template selected
   */
  getPdfTemplates() {

    this.pdfTemplates = [];
    this.fileService.getPdfTemplatesForTxnType(this.txnType, this.pdfTemplateType).subscribe(templates => {
      this.pdfTemplates = templates;
      this.setPdfTemplate();
    });
  }

  /**
   * @desc set selctedPdfTemplate if templateId is specified or there is only one template exists
   * @returns this.selectedPdfTemplate - set to the template with either matching templateId or default template
   */
  setPdfTemplate() {
    // find and set default template
    if (this.templateId && this.pdfTemplates) {
      const index = this.pdfTemplates.findIndex(template => (template.value && template.value.id == this.templateId));
      if (index >= 0) {
        this.selectedPdfTemplate = this.pdfTemplates[index].value;
        this.handler.emit(this.selectedPdfTemplate);
      } else if (this.pdfTemplates.length >= 1) {
        this.selectedPdfTemplate = this.pdfTemplates[0].value;
        this.handler.emit(this.selectedPdfTemplate);
      }
    } else {
      if (this.pdfTemplates.length == 1) {
        this.selectedPdfTemplate = this.pdfTemplates[0].value;
        this.handler.emit(this.selectedPdfTemplate);
      }
    }
  }

  /**
   * @desc emit selectedPdf
   * @param selectedPdfTemplate - user selected pdf template
   */
  onSelectPdfTemplate(selectedPdfTemplate) {
    this.handler.emit(selectedPdfTemplate);
  }

}
